import Platform from "./platform"
import axios from 'axios'
import {initDebug} from "../utils/commons"
import {getQuery} from "../utils/url"

/**
 * 西安交大APP（北京思源）
 */
class PlatformToon extends Platform {
    init() {
        initDebug()

        return new Promise((resolve, reject) => {
            try {
                axios.defaults.headers.common['app-agent'] = getQuery('ticket')
                resolve()
            } catch (e) {
                console.error(e)
                reject(e)
            }
        })
    }
}

export default PlatformToon